module.exports = __webpack_public_path__ + "img/studio_mid_with_floor.c6758fe2.png";